export default __webpack_public_path__ + "static/media/draculas-bedlam.6da98b5f.jpg";